export default __webpack_public_path__ + "c5c57643122ffd79fd7e8443727903e6.svg";